import React, { useState, useEffect, useRef } from 'react';

const Quotes = () => {
    const quotes = [
        "I asked for a feature in Discord, they built it the next week. Doesn't happen anywhere else.",
        "I've never used a tool that actually listens. They build what you ask for.",
        "Feels less like a software subscription and more like having developers on your team.",
        "Every update is something that someone asked for. You can tell they actually read the feedback."
    ];

    const [current, setCurrent] = useState(0);
    const [opacity, setOpacity] = useState(1);

    const goTo = (index) => {
        setOpacity(0);
        setTimeout(() => {
            setCurrent((index + quotes.length) % quotes.length);
            setOpacity(1);
        }, 200);
    };

    useEffect(() => {
        const timer = setInterval(() => goTo(current + 1), 5000);
        return () => clearInterval(timer);
    }, [current]);

    return (
        <div className="max-w-xl mx-auto mb-8 px-4">
            <div className="relative px-8 py-6 rounded-2xl border border-gray-200" style={{ background: 'rgba(255,255,255,0.6)', backdropFilter: 'blur(10px)' }}>
                <span className="absolute top-2 left-4 text-4xl text-teal-400 font-serif leading-none">"</span>
                <p className="text-gray-700 text-sm italic text-center leading-relaxed transition-opacity duration-200 px-2" style={{ opacity }}>
                    {quotes[current]}
                </p>
                <span className="absolute bottom-0 right-4 text-4xl text-teal-400 font-serif leading-none">"</span>
            </div>
            <div className="flex items-center justify-center gap-3 mt-3">
                <button onClick={() => goTo(current - 1)} className="w-7 h-7 rounded-full border border-gray-200 flex items-center justify-center text-gray-400 hover:text-gray-600 text-xs transition bg-white">‹</button>
                <div className="flex gap-1.5">
                    {quotes.map((_, i) => (
                        <div key={i} onClick={() => goTo(i)} className="h-1.5 rounded-full cursor-pointer transition-all duration-300"
                            style={{ width: i === current ? '20px' : '6px', background: i === current ? '#374151' : '#D1D5DB' }} />
                    ))}
                </div>
                <button onClick={() => goTo(current + 1)} className="w-7 h-7 rounded-full border border-gray-200 flex items-center justify-center text-gray-400 hover:text-gray-600 text-xs transition bg-white">›</button>
            </div>
        </div>
    );
};

export default Quotes;